import React from 'react'

// Components
import { ErrorMessage } from './ErrorMessage'

interface Props {
    children: React.ReactNode
    name: string
    value: string
    errorMessage?: string,
    checked?: boolean
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export const InputCheckbox: React.FC<Props> = ({ children, name, value, errorMessage, checked, onChange }) => {
    return (
        <div className="membership-app__choice membership-app__choice--checkbox">
            <label className="membership-app__choice-container">
                {children}
                <input type={'checkbox'} name={name} value={value} onChange={onChange} checked={checked} />
                <span className={'membership-app__choice-checkmark'} />
            </label>
            {errorMessage && <ErrorMessage message={errorMessage} />}
        </div>
    )
}